import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine1 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#FFBE00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1626 18.6934V5.44148H11.8539C11.2534 5.91079 9.82673 6.79305 8.2876 7.52479L7.48047 7.90018L8.38151 9.9274L9.07595 9.57079C9.56403 9.32661 10.8966 8.63218 11.3473 8.27557V18.6931H14.1626V18.6934Z",
			fill: "black"
		})
	]
});
const ForwardRef = forwardRef(SvgLine1);
export { ForwardRef as ReactComponent };
